export default {
  countries(state) {
    return state.countries;
  },
  getterMiscSetting(state) {
    return state.miscSettings;
  },
  hasUnreadNotifications(state) {
    return !!state.notifications.find((el) => !el.is_read);
  },
};
